






























































































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { ActivitySessionAttendee } from '@activities/interfaces/activity-session-attendee';
import NotifySummonsAttendeeModal from '@activities/components/modals/notify-summons-attendee-modal/notify-summons-attendee-modal.vue';

@Component({
  name: 'bpc-game-summary-card',
  components: {
    'bpc-notify-summons-attendee-modal': NotifySummonsAttendeeModal,
  },
})
export default class GameSummaryCard extends Vue {
  // PROPS
  @Prop([String, Number]) readonly gameId: string | number;

  // DATA
  summons: ActivitySessionAttendee[] = null;
  showNotifySummonModal: boolean = false;
  attendeeIdsToNotify: number[] = [];
  attendeeSelectableCondition: string = null;

  // COMPUTED
  get totalSummoned() {
    return this.summons?.length || 0;
  }
  get totalConfirmed() {
    return this.summons?.filter(item => item.coming === 'yes').length;
  }
  get totalMissing() {
    return this.summons?.filter(item => item.coming === 'no').length;
  }
  get totalWaiting() {
    return this.summons?.filter(item => item.coming === null).length;
  }
  // LIFE CYCLE
  mounted() {
    this.getSummonedAttendees();
  }
  // METHODS
  getSummonedAttendees() {
    const queryConfig = {
      params: {
        summoned: 1,
        activity_session_id: this.gameId,
        per_page: -1,
      },
    };
    this.$bpcApi
      .get(this.$bpcApiRouteHelper.getEntityPath('activity-session-attendee'), queryConfig)
      .subscribe(
        (res: BPCGenericApiResponse) => {
          this.summons = res.data;
        },
        error => {
          console.log(error);
        },
      );
  }

  openNotifySummonModal(action) {
    switch (action) {
      case 'confirmed':
        this.attendeeSelectableCondition = 'confirmed';
        this.attendeeIdsToNotify = this.summons
          ?.filter(item => item.coming === 'yes')
          .map(item => item.id);
        break;
      case 'missing':
        this.attendeeSelectableCondition = 'missing';
        this.attendeeIdsToNotify = this.summons
          ?.filter(item => item.coming === 'no')
          .map(item => item.id);
        break;
      case 'waiting':
        this.attendeeSelectableCondition = 'waiting';
        this.attendeeIdsToNotify = this.summons
          ?.filter(item => item.coming === null)
          .map(item => item.id);
        break;
      default:
        this.attendeeSelectableCondition = null;
        this.attendeeIdsToNotify = this.summons?.map(item => item.id);
    }
    this.showNotifySummonModal = true;
  }

  onCloseAddSummonModal() {
    this.showNotifySummonModal = false;
    this.attendeeIdsToNotify = [];
    this.attendeeSelectableCondition = null;
  }
  // WATCHERS
}
